<div class="table-header">
  <span>Join Servers</span>
  <!-- <div class="table-filter">
    <form class="form-inline join-servers-select short">
      <select id="" class="table-filter-search form-control">
        <option></option>
        <option></option>
        <option></option>
      </select>
    </form>
  </div> -->
  <div class="position-relative table-icon action">
    <i class="fa fa-list transition text-tooltip" aria-hidden="true" title-popup="List"></i>
    <div class="tooltip-actions width-120">
      <div class="arrow-up"></div>
      <ul>
        <li>
          <label col-id="0" table-name="join-servers-list" class="checked">joinEui</label>
        </li>
        <li>
          <label col-id="1" table-name="join-servers-list" class="checked">Name</label>
        </li>
        <!-- <li>
          <label col-id="2" table-name="join-servers-list" class="checked">Status</label>
        </li> -->
        <!--<li>-->
        <!--<label col-id="3" table-name="join-servers-list" class="checked">Alarms</label>-->
        <!--</li>-->
        <li>
          <label *ngIf="isAdmin" col-id="2" table-name="join-servers-list" class="checked">Owner</label>
        </li>
        <li>
          <label *ngIf="isAdmin" col-id="3" table-name="join-servers-list" class="checked">Owner's Affiliation</label>
        </li>
      </ul>
    </div>
  </div>
  <div *ngIf="isAdmin" class="table-icon plus">
    <i [routerLink]="['/create-join-servers']" class="fa fa-plus transition text-tooltip" aria-hidden="true" title-popup="Add"></i>
  </div>
</div>
<div class="table-panel">
<table class="table table-striped" id="join-servers-list">
  <thead>
    <tr>
      <th>JoinEUI</th>
      <th>Name</th>
      <!-- <th>Status</th> -->
      <!--<th>Alarms</th>-->
      <th *ngIf="isAdmin">Owner</th>
      <th *ngIf="isAdmin">Owner's Affiliation</th>
      <th *ngIf="isAdmin"></th>
    </tr>
  </thead>

  <tbody>
  <tr *ngFor="let item of list | paginate: configPagerGetAllJoinServers">
    <td class="servingJoinServers-joinEUI-td"><a [routerLink]="['/join',item.virtId]">{{item.joinEUIs | cidr}}</a></td>
    <td><a [routerLink]="['/join',item.virtId]">{{item.name}}</a></td>
    <!-- <td>{{item.status}}</td> -->
    <td *ngIf="isAdmin">{{item.username}}</td>
    <td *ngIf="isAdmin">{{item.affiliation}}</td>
    <td *ngIf="isAdmin">
      <ng-template #actionsPopup>
        <p class="popup-text"
           (click)="userDetail.show();getUserDetails(item.username)"
           *ngIf="item.username">User details</p>
          <app-modal #userDetail
                     ownerUname="{{ownerUname}}"
                     ownerFname="{{ownerFname}}"
                     ownerLname="{{ownerLname}}"
                     ownerEmail="{{ownerEmail}}"
                     ownerAffiliation="{{ownerAffiliation}}"></app-modal>

        <!--Impersonate popover option-->
        <!--<p class="popup-text">Impersonate</p>-->

        <p class="popup-text"
           (click)="deleteModal.show()">Delete</p>
      </ng-template>

        <button class="view-detail-btn"
                [popover]="actionsPopup"
                placement="left"
                triggers="click"
                [outsideClick]="true"
                container="body">...
        </button>
        <app-delete-modal #deleteModal
                          text="Join Server {{item.name}} will be deleted."
                          server="{{item.virtId}}"
                          deleteType="joinServer"></app-delete-modal>

      </td>
    </tr>

  </tbody>
</table>
</div>
<app-pagination-custom [config]="configPagerGetAllJoinServers"></app-pagination-custom>
